/**
 * created by lei lei
 *原创稿件数据请求
 * 新闻网，微信。微博
 */
import *as utils from '../utils'
import { post, headerJson } from './index' ;
import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';
const Apis = {
    getOriginalList: host + 'originalStory/originalList',//获取原创稿件列表
    downloadStoryById: host + 'storyNew/downloadStoryById',//下载稿件
    getWebsiteStoryPublishUrl: host + 'storyNew/getWebsiteStoryPublishUrl',//已发布媒体查看
    delStoryById: host + 'storyNew/delStoryById',//删除稿件
    getAllMedia: host + 'media/getAll',//获取全部媒体媒体
    getPublishResource: host + 'originalStory/getPublishResource',//根据媒体code获取稿件列表
    removeResource: host + 'website/removeResource',//移除稿件
    getResourcePool: host + 'originalStory/getResourcePool',//获取投稿稿件
    addToEditor: host + 'material/compose', //拾取至编辑器
    publish: host + 'manuscript/publish', //其他媒体 发布
};

//获取原创稿件列表
export function getOriginalList(body, callBack) {
    let url = Apis.getOriginalList;
    request({url:Apis.getOriginalList, method:"post", body, callBack});
}

//下载稿件
export function downloadStoryById(body, callBack) {
    let url = Apis.downloadStoryById + utils.params(body)+'&time='+new Date().getTime();
    callBack(url)
}

//已发布媒体查看
export function getWebsiteStoryPublishUrl(body, callBack) {
    let url = Apis.getWebsiteStoryPublishUrl;
    request({url, body, callBack});
}

//删除稿件
export function delStoryById(body, callBack) {
    let url = Apis.delStoryById;
    request({url, body, callBack});
}
//移除稿件
export function removeResource(body, callBack) {
    let url = Apis.removeResource;
    request({url, body, callBack});
}

//获取全部媒体
export function getAllMedia( callBack) {
    let url = Apis.getAllMedia;
    request({url, callBack});
}

//投稿稿件
export function getResourcePool(body, callBack) {
    let url = Apis.getResourcePool;
    request({url, body, callBack});
}

//获取其他媒体稿件
export function getPublishResource(body, callBack) {
    let url = Apis.getPublishResource;
    request({url, body, callBack});
}

//拾取至编辑器
export function addToEditor(body, callBack) {
    let url = Apis.addToEditor;
    request({url, body, method:"post", callBack});
}

//其他媒体发布
export const publish = (body, callBack) => {
    request({url:Apis.publish, body, method:"post", callBack});
}
